import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'

class GakkoFamily extends Component {
  render() {
    let data,
        family, familyDescription, theGakko
    if (this.props && this.props.data) {
      data = this.props.data
      theGakko = data['the-gakko']
      family = data['family']
      familyDescription = data['family-description']
    }

    return (
      <div className="center">
        <section className="main-grid">
          <ul className="grid group">
            <li className="grid-small">
              <h3>The Gakko Family</h3>
            </li>
            <li className="grid-middle grid-small">
              <p>The Gakko team is but a sliver of a talented & ever-growing community that makes this project possible.</p>
            </li>
          </ul>
        </section>

        <section className="about-mosaic top-xl">
          <img src={assets('images/gakko_family.jpg')} />
        </section>
      </div>
    )
  }
}
GakkoFamily.contextTypes = {
}
GakkoFamily.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location
  }
}

export default connect(mapStateToProps)(GakkoFamily)



// WEBPACK FOOTER //
// ./src/components/OurStory/GakkoFamily.js